import { axios } from 'libs';

import { removeSolicitacaoJson } from './ProcessoPayload';

const resource = '/processos-observadores-externos';

export const sendEmail = id => {
  return axios.post(`${resource}/${id}/send-email`);
};

export const save = values => {
  return axios.post(`${resource}`, {
    ...values,
    processo: removeSolicitacaoJson(values.processo)
  });
};

export const remove = id => {
  return axios.delete(`${resource}/${id}`);
};
